export function Error404() {
    return (
        <>
            <div class='bf-ui-content'><div class='container'>
                <div class='bf-error-wrapper'>
                    <h1>Page not found</h1>
                    <p>Page {location.pathname} was not found. It may have been moved or you do not have sufficient permission to access it</p>
                    <a class='bf-action mt-2' href='/'>Return</a>
                </div>
            </div></div>
        </>
    );
}
